import {
    DeleteQuizAPIParams,
    GetQuizByIdParams,
    GetQuizForTrackParams,
    GetQuizLanguagesParams,
    SaveQuizParams,
} from "../types/requestInputs";
import { GetQuizByIdResponse, GetQuizForTrackResponse, GetQuizLanguagesResponse } from "../types/requestsOutputs";
import { MessageResponse } from "../types/types";
import { fetchAPI } from "./utils";

export const getQuizLanguages = async ({
    token,
    quizId,
}: GetQuizLanguagesParams): Promise<GetQuizLanguagesResponse> => {
    return fetchAPI<GetQuizLanguagesResponse>("/get-quiz-languages", "POST", { quizId }, token);
};

export const getQuizById = async ({
    token,
    trackId,
    quizId,
    language,
}: GetQuizByIdParams): Promise<GetQuizByIdResponse> => {
    return fetchAPI<GetQuizByIdResponse>("/get-quiz-by-language", "POST", { trackId, quizId, language }, token);
};

export const saveQuiz = async ({
    token,
    trackId,
    quizId,
    latitude,
    longitude,
    address,
    position,
    language,
    question,
    explanation,
    choices,
    picture,
}: SaveQuizParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>(
        "/save-quiz",
        "POST",
        { trackId, quizId, latitude, longitude, address, position, language, question, explanation, choices, picture },
        token,
    );
};

export const getQuizForTrack = async ({ token, trackId }: GetQuizForTrackParams): Promise<GetQuizForTrackResponse> => {
    return fetchAPI<GetQuizForTrackResponse>("/get-track-quizz", "POST", { trackId }, token);
};

export const deleteQuizAPI = async ({ token, trackId, quizId }: DeleteQuizAPIParams): Promise<MessageResponse> => {
    return fetchAPI<MessageResponse>("/delete-quiz", "POST", { trackId, quizId }, token);
};
